import React from 'react';

import {
  Col,
  Image,
  Row
} from 'react-bootstrap';

import father from "../../imgs/chilis/ProjectMayanRainbow/father.jpg";
import mother from "../../imgs/chilis/ProjectMayanRainbow/mother.jpg";
import theAct0 from "../../imgs/chilis/ProjectMayanRainbow/the-act-0.jpg";
import theAct1 from "../../imgs/chilis/ProjectMayanRainbow/the-act-1.jpg";
import f1Fruits from "../../imgs/chilis/ProjectMayanRainbow/F1-fruits.jpg";
import f1TimeLapse from "../../imgs/chilis/ProjectMayanRainbow/timelapse_x265.mp4";

import noWhite0 from "../../imgs/chilis/ProjectMayanRainbow/F2 fails/no_white_orange_0.jpg";
import groupyWrongColors from "../../imgs/chilis/ProjectMayanRainbow/F2 fails/groupy_wrong_colors.jpg";
import uncleanColors from "../../imgs/chilis/ProjectMayanRainbow/F2 fails/unclean_color_transition.jpg";
import smallFruit from "../../imgs/chilis/ProjectMayanRainbow/F2 fails/small_fruits.jpg";
import weakPurple from "../../imgs/chilis/ProjectMayanRainbow/F2 fails/weak_purple.jpg";

import mr0 from "../../imgs/chilis/ProjectMayanRainbow/F2 success/MR0.jpg";
import mr1 from "../../imgs/chilis/ProjectMayanRainbow/F2 success/MR1.jpg";
import bpp0 from "../../imgs/chilis/ProjectMayanRainbow/F2 success/BPP0.jpg";
import mf0 from "../../imgs/chilis/ProjectMayanRainbow/F2 success/MF0.jpg";

const ProjectMayanRainbow = () => {


  return (
    <div className="mb-4 pb-4">
      <center><h1>Project Mayan Rainbow</h1></center><br/>

      <center><h3>Meet the parents</h3></center><br/>
      <Row className='m-0'>
        <Col sm={4} md={4} lg={4} className='m-0'>
          <center>
            Bolivian Rainbow<br/>
            <Image
              className='m-1'
              style={{'height' : '40vh', 'width': 'auto'}}
              src={father}
              alt="Image of father F0 plant"
            /><br/>
            F0 father plant (pollen source)
          </center>
        </Col>
        <Col sm={4} md={4} lg={4} className='m-0'>
          <center>
            Why this cross?<br/>
            Well, I love the color pattern of the Bolivian Rainbow fruits. Sadly, the fruits are a bit small and fully packed with seeds.
            That combined with relatively thin flesh, it's hard to enjoy the fruits of the Bolivian Rainbow for me.<br/>
            Furthermore the sheer amount of fruits, especially when you have multiple plants, takes really long to harvest.<br/><br/>
            That's why I've decided to cross the Bolivian Rainbow with the Maya Purple Passion in order to get a cross that has the same color scheme as the
            Bolivian Rainbow has but the fruit size would be more in line with the Maya Purple Passion.<br/>
            That's the idea anyways.
          </center>
        </Col>
        <Col sm={4} md={4} lg={4} className='m-0'>
          <center>
            Maya Purple Passion<br/>
            <Image
              className='m-1'
              style={{'height' : '40vh', 'width': 'auto'}}
              src={mother}
              alt="Image of mother F0 plant"
            /><br/>
            F0 mother plant (flower plant)
          </center>
        </Col>
      </Row>

      <center><h3>The act of crossing</h3></center><br/>
      <Row className='m-0'>
        <Col sm={4} md={4} lg={4} className='m-0'>
          <center>
            <Image
              className='m-1'
              style={{'height' : '24vh', 'width': 'auto'}}
              src={theAct0}
              alt="Image of polinated flower"
            />
          </center>
        </Col>
        <Col sm={4} md={4} lg={4} className='m-0'>
          <center>
            Here are just two pictures from the process of applying the pollen of the father to the flower of the mother and shortly after.
          </center>
        </Col>
        <Col sm={4} md={4} lg={4} className='m-0'>
          <center>
            <Image
              className='m-1'
              style={{'height' : '40vh', 'width': 'auto'}}
              src={theAct1}
              alt="Image of polinated flower"
            />
          </center>
        </Col>
      </Row>

      <center><h3>The F1 generation</h3></center><br/>
      <Row className='m-0'>
        <Col sm={4} md={4} lg={4} className='m-0'>
          <center>
            <Image
              className='m-1'
              style={{'height' : '24vh', 'width': 'auto'}}
              src={f1Fruits}
              alt="Image of fruits of F1 plant"
            />
          </center>
        </Col>
        <Col sm={4} md={4} lg={4} className='m-0'>
          <center>
            This part is about the F1 generation.<br/>
            I raised two F1 plants inside. Pollinated by hand to avoid pollination through other plants.<br/>
            On the left you can see a preview picture of how the fruits of the F1 fruits looked, already showing
            characteristics of the fruits of both parent plants!<br/>
            On the right there is an entire time lapse of the F1 plants growing and producing fruits until harvest!
          </center>
        </Col>
        <Col sm={4} md={4} lg={4} className='m-0'>
          <center>
            <video style ={{'height': '25vh', 'width': 'auto'}} autoPlay controls muted>
              <source src={f1TimeLapse} type="video/mp4"></source>
            </video><br/>
            (framerate on Browser isn't optimal, sorry for that)
          </center>
        </Col>
      </Row>


      <center><h2>The F2 generations</h2></center><br/>

      <center><h3>The 'failed' F2 plants</h3></center><br/>
      <Row className='m-0'>
        <Col sm={4} md={4} lg={4} className='m-0'>
          <center>
            <Image
              className='m-1'
              style={{'height' : 'auto', 'width': '10vw'}}
              src={noWhite0}
              alt="Image of F2 plant with no white or orange phase for fruits"
            /><br/>
            This plant's fruits didn't have a white or orange phase and went straight from purple to red.
          </center>
        </Col>
        <Col sm={4} md={4} lg={4} className='m-0'>
          <center>
            This part is about the F2 plants that didn't have what i was looking for in this cross.<br/>
            For each plant in this section there was (a) specific reason(s) for why i didn't like this variant of the cross.<br/>
            These are just a selection of the plants I rejected.<br/>
            In total i grew 16 plants in F2, of which I only took 4 of into the next generation. 
          </center>
        </Col>
        <Col sm={4} md={4} lg={4} className='m-0'>
          <center>
            <Image
              className='m-1'
              style={{'height' : 'auto', 'width': '10vw'}}
              src={groupyWrongColors}
              alt="Image of F2 plant with grouping pale fruits"
            /><br/>
            This plant's fruits grouped up and were way too pale in their color stages. I want seperate fruits with this project.
          </center>
        </Col>
      </Row>
      <Row className='m-0 mt-3'>
        <Col sm={4} md={4} lg={4} className='m-0'>
          <center>
            <Image
              className='m-1'
              style={{'height' : 'auto', 'width': '10vw'}}
              src={weakPurple}
              alt="Image of F2 plant with fruits that were never truly fully purple."
            /><br/>
            This plant's fruits weren't really purple when starting out. There were weak signs of purple,
            but the full fruit was more white from the start and didn't have a full deep purple phase as i would have liked.
          </center>
        </Col>
        <Col sm={4} md={4} lg={4} className='m-0'>
          <center>
            <Image
              className='m-1'
              style={{'height' : 'auto', 'width': '10vw'}}
              src={uncleanColors}
              alt="Image of F2 plant with fruits that were unclean in color transition"
            /><br/>
            This plant's fruits were transitioning from purple into red with an uneven transition, resulting in mixed color fruits.
            While this looked cool, it wasn't at all what i was after with this project.
          </center>
        </Col>
        <Col sm={4} md={4} lg={4} className='m-0'>
          <center>
            <Image
              className='m-1'
              style={{'height' : 'auto', 'width': '10vw'}}
              src={smallFruit}
              alt="Image of F2 plant with small fruits and unwanted shape"
            /><br/>
            This plant's fruits were too small and had a bad shape. I wanted to get away from the Bolivian Rainbow fruit shape and especially fruit size,
            so this mutation definitely wasn't what i was looking for.
          </center>
        </Col>
      </Row>

      <br/><br/>
      <center><h3>The successful F2 plants</h3></center><br/>
      <Row className='m-0'>
        <Col sm={4} md={4} lg={4} className='m-0'>
          <center>
            <Image
              className='m-1'
              style={{'height' : 'auto', 'width': '10vw'}}
              src={mr0}
              alt="Image of good looking F2 plant"
            /><br/>
            This plant's fruits had the correct color scheme and a good size/shape.<br/>
            The plant is a taller growing plant (though much of that is due to the dense plant population of my windows.)<br/>
          </center>
        </Col>
        <Col sm={4} md={4} lg={4} className='m-0'>
          <center>
            This part is about the F2 plants that had what I was looking for in this crossing project.<br/>
            These two plants both had the correct (though slightly different) coloring scheme and the fruit shape and size
            on both plats looked good.<br/>
          </center>
        </Col>
        <Col sm={4} md={4} lg={4} className='m-0'>
          <center>
            <Image
              className='m-1'
              style={{'height' : 'auto', 'width': '10vw'}}
              src={mr1}
              alt="Image of F2 plant with grouping pale fruits"
            /><br/>
            This plant's fruits also had the correct color scheme and good fruit shape/size.<br/>
            This plant is a more bushier growing plant.<br/>
          </center>
        </Col>
      </Row>


      <br/><br/>
      <center><h3>The accidental F2 successes</h3></center><br/>
      <Row className='m-0'>
        <Col sm={4} md={4} lg={4} className='m-0'>
          <center>
            <Image
              className='m-1'
              style={{'height' : 'auto', 'width': '10vw'}}
              src={bpp0}
              alt="Image of an accidentally successfully F2 plant"
            /><br/>
            This plant's fruits had the same coloring scheme of the F0 mother plant.<br/>
            This intruiged me as the mother's chilis variety's plants aren't the most productive and biggest and in my experience
            not really the healthiest growing wise.<br/>
            So having a plant less bushy and seemingly more productive is something that I would certainly really like.<br/>
          </center>
        </Col>
        <Col sm={4} md={4} lg={4} className='m-0'>
          <center>
            This part is about F2 plants that definitely aren't wat i was looking for but still had something that wanted me to continure growing the variety.<br/>
            You can follow the progress of the varieties' journeys on their respective subsites linked below their pictures.<br/>
          </center>
        </Col>
        <Col sm={4} md={4} lg={4} className='m-0'>
          <center>
            <Image
              className='m-1'
              style={{'height' : 'auto', 'width': '10vw'}}
              src={mf0}
              alt="Image of an accidentally successfully F2 plant"
            /><br/>
            This plant's fruits were kind of white in the beginning although both parent's fruits start out as purple.<br/>
            This intruiged me immediately and i decided to see were this plant was going.<br/>
            The fruits ripened into the typical chili pepper red, which of course isn't that interesting,
            but i decided to save a few seeds and maybe continue growing this variety.<br/>
          </center>
        </Col>
      </Row>

      
    </div>
  )
}

export default ProjectMayanRainbow;